/* ============================================================================
   VITRINAS — el lado del vendedor
   ---------------------------------------------------------------------------
   Crear la seleccion, copiar el enlace para WhatsApp y ver que hizo el
   cliente: si la abrio, que miro y que no pidio.

   La vitrina se arma desde lo que el vendedor YA tiene en el carrito de Nuevo
   pedido. No hay una pantalla nueva de elegir productos: elige como siempre y
   en vez de enviar la cotizacion, manda la vitrina.
============================================================================ */

var VT_BASE = '/pages/vitrina';     // la pagina publica en Shopify
var SH_BASE = '/pages/showroom';    // el showroom, tambien publico
var VT_LISTA = [];

function vtEsc(s){
  return String(s==null?'':s).replace(/[&<>"]/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];
  });
}
function vtYo(){
  try{ return String((CU&&(CU.username||String(CU.email||'').split('@')[0]))||''); }
  catch(e){ return ''; }
}
function vtNombre(){
  try{ return String((CU&&(CU.nombre||CU.username))||'').trim(); }catch(e){ return ''; }
}

// Codigo corto del enlace. Sin vocales ni caracteres que se confundan al
// dictarlos por telefono: nada de 0/O ni 1/l.
function vtCodigo(n){
  var a='23456789bcdfghjkmnpqrstvwxz', s='';
  var r=(window.crypto&&crypto.getRandomValues)
    ? crypto.getRandomValues(new Uint32Array(n||7)) : null;
  for(var i=0;i<(n||7);i++){
    s += a[(r ? r[i] : Math.floor(Math.random()*4e9)) % a.length];
  }
  return s;
}

// ══════════════════════════════════════════════════════════════════════════
//  VITRINA DESDE UN PEDIDO QUE YA EXISTE
//  --------------------------------------------------------------------------
//  El cliente revisa su pedido y pide cambios. Lo que manda NO toca el
//  pedido: se guarda como propuesta y el vendedor decide.
//
//  Es deliberado. Un pedido en SAP puede estar autorizado, con mercancia
//  separada en bodega y hueco en un contenedor. Que el cliente lo cambie
//  desde su telefono sin que nadie lo mire romperia todo lo que viene detras.
// ══════════════════════════════════════════════════════════════════════════

async function vtDesdePedido(docnum){
  var btn = document.getElementById('ped-vt');
  var txt0 = btn ? btn.innerHTML : '';
  if(btn){ btn.disabled = true; btn.textContent = 'Preparando\u2026'; }
  try{
    // La tabla es `pedidos`, y trae cabecera Y lineas: una fila por linea.
    // `vista_pedidos` es otra cosa -los porcentajes de avance- y no tiene
    // estas columnas. Daba 400.
    var cab = await q('pedidos',
      'select=docnum,cardcode,cardname,slpcode,nombrevendedor&docnum=eq.'
      + encodeURIComponent(docnum) + '&limit=1') || [];
    if(!cab.length) throw new Error('No encontr\u00e9 el pedido ' + docnum + '.');
    cab = cab[0];

    var lin = await qAll('pedidos',
      'select=linenum,itemcode,dscription,quantity,price,descuentolinea,openqty'
      + '&docnum=eq.' + encodeURIComponent(docnum) + '&order=linenum') || [];
    // Lo ya servido no se manda a revisar: esa mercancia salio y cambiarla
    // no tendria efecto.
    lin = lin.filter(function(l){
      return l.itemcode && (l.openqty == null || Number(l.openqty) > 0);
    });
    if(!lin.length) throw new Error('Ese pedido no tiene l\u00edneas.');

    var info = await vtFotos(lin.map(function(l){ return l.itemcode; }));

    var cod = vtCodigo(7), dias = 7;
    var v = await vtEscribir('POST', 'vitrinas', {
      codigo: cod,
      cardcode: cab.cardcode,
      cardname: cab.cardname || cab.cardcode,
      slpcode: cab.slpcode || null,
      vendedor: vtYo(),
      vendedor_nom: vtNombre(),
      titulo: 'Pedido #' + docnum,
      mensaje: 'Revise su pedido. Si algo no est\u00e1 bien, c\u00e1mbielo y env\u00edelo; '
             + 'yo lo confirmo antes de despacharlo.',
      pin: null,
      vence_en: new Date(Date.now() + dias*86400000).toISOString(),
      // Esto es lo que la convierte en revision y no en pedido nuevo.
      pedido_docnum: Number(docnum),
      revision: 'pendiente'
    }, true);
    if(!v || !v[0]) throw new Error('No se pudo crear la vitrina.');

    var items = lin.map(function(l, i){
      var x = info[l.itemcode] || {};
      // En esta tabla el descuento se llama `descuentolinea`.
      var desc = Number(l.descuentolinea)||0, pre = Number(l.price)||0;
      return {
        vitrina_id: v[0].id,
        itemcode: l.itemcode,
        itemname: l.dscription || l.itemcode,
        frgnname: x.frgnname || null,
        foto_url: x.foto_url || null,
        // El precio ya cerrado del pedido, no el de catalogo.
        precio: Math.round(pre * (1-desc/100) * 100)/100,
        precio_lista: desc ? pre : null,
        bulto: Math.max(1, Number(x.unidadesbulto)||1),
        // Lo PENDIENTE de servir, que es sobre lo que puede opinar. Si ya
        // le entregaron la mitad, mostrarle el total confunde.
        cantidad: Number(l.openqty != null ? l.openqty : l.quantity)||0,
        ficha: x.ficha || null,
        orden: i
      };
    });
    await vtEscribir('POST', 'vitrina_items', items);

    vtMostrarEnlace(cod, null, dias, cab.cardname || cab.cardcode,
                    items.length, docnum);
  }catch(e){
    alert('No se pudo preparar la revisi\u00f3n: ' + (e.message||e));
  }finally{
    if(btn){ btn.disabled = false; btn.innerHTML = txt0; }
  }
}

// ── El dialogo previo ───────────────────────────────────────────────────────
// Se pregunta antes de crear: una vitrina mandada con el saludo equivocado o
// siete dias cuando querias dos no se puede corregir despues sin mandar otra.
function vtPreguntar(){
  if(!npCli || !npCli.cardcode){ alert('Elige primero el cliente.'); return; }
  if(!npLineas || !npLineas.length){ alert('Agrega productos antes de armar la vitrina.'); return; }

  var m=document.createElement('div');
  m.id='vt-pre';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;'
    +'max-width:460px;width:100%;padding:20px">'
    +'<div style="font-size:16px;font-weight:700;margin-bottom:3px">'
    +'Mandar por WhatsApp</div>'
    +'<div style="font-size:13px;color:var(--text3);margin-bottom:15px">'
    +npLineas.length+' producto(s) para <b>'+vtEsc(npCli.cardname||npCli.cardcode)
    +'</b>, con los precios que acabas de poner.</div>'

    +'<label style="font-size:12px;font-weight:700;text-transform:uppercase;'
    +'letter-spacing:.04em;color:var(--text3)">Saludo</label>'
    +'<textarea id="vt-msg" rows="2" class="inp" style="width:100%;margin:5px 0 14px" '
    +'placeholder="Mira lo que llegó esta semana">'
    +'</textarea>'

    +'<div style="display:flex;gap:14px;align-items:center;flex-wrap:wrap">'
      +'<div><label style="font-size:12px;font-weight:700;text-transform:uppercase;'
      +'letter-spacing:.04em;color:var(--text3)">Vence en</label><br>'
      +'<select id="vt-dias" class="inp" style="margin-top:5px">'
        +'<option value="2">2 días</option>'
        +'<option value="4">4 días</option>'
        +'<option value="7" selected>7 días</option>'
        +'<option value="15">15 días</option>'
      +'</select></div>'
      +'<label style="display:flex;align-items:center;gap:7px;font-size:13px;'
      +'margin-top:18px"><input type="checkbox" id="vt-pin"> '
      +'Pedir código de acceso</label>'
    +'</div>'
    +'<div style="font-size:11.5px;color:var(--text3);margin-top:7px;line-height:1.5">'
    +'Sin código, cualquiera con el enlace ve tus precios. Con código, se lo dictas '
    +'por teléfono.</div>'

    +'<div style="display:flex;gap:8px;margin-top:17px">'
      +'<button class="btn btn-p" onclick="vtCrear()">Crear la vitrina</button>'
      +'<button class="btn" style="margin-left:auto" '
      +'onclick="document.getElementById(\'vt-pre\').remove()">Cancelar</button>'
    +'</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}

// ── Crear desde el carrito ──────────────────────────────────────────────────
async function vtCrear(){
  if(!npCli || !npCli.cardcode){ alert('Elige primero el cliente.'); return; }
  if(!npLineas || !npLineas.length){ alert('Agrega productos antes de armar la vitrina.'); return; }

  var dias = parseInt((document.getElementById('vt-dias')||{}).value, 10) || 7;
  var msg  = ((document.getElementById('vt-msg')||{}).value || '').trim();
  var conPin = !!(document.getElementById('vt-pin')||{}).checked;
  var pin = conPin ? String(Math.floor(1000 + Math.random()*9000)) : null;

  var pre=document.getElementById('vt-pre'); if(pre) pre.remove();

  var cod = vtCodigo(7);
  var vence = new Date(Date.now() + dias*86400000).toISOString();

  try{
    // 1. La vitrina
    var v = await vtEscribir('POST', 'vitrinas', {
      codigo: cod,
      cardcode: npCli.cardcode,
      cardname: npCli.cardname || npCli.cardcode,
      slpcode: (CU && CU.slpcode) || null,
      vendedor: vtYo(),
      vendedor_nom: vtNombre(),
      titulo: 'Selección para ' + (npCli.cardname || npCli.cardcode),
      mensaje: msg || null,
      pin: pin,
      vence_en: vence
    }, true);
    if(!v || !v[0]) throw new Error('No se pudo crear la vitrina.');
    var vid = v[0].id;

    // 2. Las lineas, con el precio que el vendedor ya fijo. Se guarda, no se
    //    recalcula: si prometio 270, el cliente vera 270 aunque cambie la lista.
    var fotos = await vtFotos(npLineas.map(function(l){ return l.itemcode; }));
    var items = npLineas.map(function(l, i){
      var desc = Number(l.discount)||0;
      var pFinal = Math.round((Number(l.price)||0) * (1-desc/100) * 100)/100;
      return {
        vitrina_id: vid,
        itemcode: l.itemcode,
        itemname: l.itemname || l.itemcode,
        frgnname: (fotos[l.itemcode]||{}).frgnname || null,
        foto_url: (fotos[l.itemcode]||{}).foto_url || null,
        precio: pFinal,
        precio_lista: desc ? (Number(l.price)||0) : null,
        bulto: Math.max(1, Number(l.bulto)||1),
        // Lo que el vendedor dejo puesto: el cliente ajusta sobre eso.
        cantidad: Number(l.quantity)||0,
        ficha: (fotos[l.itemcode]||{}).ficha || null,
        orden: i
      };
    });
    await vtEscribir('POST', 'vitrina_items', items);

    vtMostrarEnlace(cod, pin, dias, npCli.cardname || npCli.cardcode, items.length);
  }catch(e){
    alert('No se pudo crear la vitrina: ' + (e.message||e));
  }
}

// La foto y el nombre en ingles de cada articulo.
//
// `frgnname` se pedia pero no se seleccionaba, asi que siempre llegaba vacio.
// Y si `vista_inventario` no trae la foto, se busca en `inventario`, que es
// donde vive de verdad en algunas filas.
async function vtFotos(codes){
  var out={};
  try{
    for(var i=0;i<codes.length;i+=200){
      var lote=codes.slice(i,i+200)
        .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      // `vista_inventario` SI tiene caracteristicas, codebars, marca y
      // unidadesbulto. Lo unico que NO tiene es `frgnname`, y pedirselo hacia
      // que PostgREST devolviera 400 y se perdiera todo, fotos incluidas.
      var r=await q('vista_inventario',
        'select=itemcode,foto_url,peso,volumen,unidadesbulto,marca,codebars,'
        +'caracteristicas&itemcode=in.('+lote+')&limit='+lote.length);
      (r||[]).forEach(function(x){ out[x.itemcode]=x; });
    }
    // El nombre en ingles y la marca viven en `inventario`, no en la vista.
    for(var j=0;j<codes.length;j+=200){
      var l2=codes.slice(j,j+200)
        .map(function(c){ return '"'+String(c).replace(/"/g,'')+'"'; }).join(',');
      try{
        var r2=await q('inventario',
          'select=itemcode,frgnname,marca,foto_url&itemcode=in.('+l2+')&limit='+l2.split(',').length);
        (r2||[]).forEach(function(x){
          out[x.itemcode]=out[x.itemcode]||{};
          if(x.frgnname) out[x.itemcode].frgnname=x.frgnname;
          if(x.marca)    out[x.itemcode].marca=x.marca;
          if(!out[x.itemcode].foto_url && x.foto_url) out[x.itemcode].foto_url=x.foto_url;
        });
      }catch(e){}
    }
    // La ficha se arma al final, con todo lo reunido.
    Object.keys(out).forEach(function(c){ out[c].ficha = vtFicha(out[c]); });
  }catch(e){}
  return out;
}

// La ficha que vera el cliente, con los mismos campos del informe de
// recepcion. Se GUARDA al crear la vitrina, igual que el precio: lo que vio
// el cliente es lo que se cotizo, aunque el catalogo cambie despues.
function vtCar(c, claves){
  if(!c || typeof c!=='object') return '';
  var keys=Object.keys(c);
  for(var i=0;i<keys.length;i++){
    var kl=keys[i].toLowerCase();
    for(var j=0;j<claves.length;j++){
      if(kl.indexOf(claves[j])>=0 && c[keys[i]]!=null && c[keys[i]]!=='')
        return String(c[keys[i]]);
    }
  }
  return '';
}

function vtFicha(x){
  var c = (x.caracteristicas && typeof x.caracteristicas==='object')
          ? x.caracteristicas : null;
  var ub = Math.max(1, Number(x.unidadesbulto)||1);
  var f = {};

  var v;
  if((v=vtCar(c,['composicion','composition'])))      f.composicion = v;
  if((v=vtCar(c,['color'])))                           f.colores     = v;
  if((v=vtCar(c,['tamano','tama','medida','size'])))   f.tamano      = v;
  if((v=vtCar(c,['tamanobulto','tamano bulto','bultosize']))) f.tamanoBulto = v;
  if((v=vtCar(c,['porigen','origen','origin'])))       f.origen      = v;
  if((v=vtCar(c,['tipo'])))                            f.tipo        = v;

  if(x.marca)    f.marca    = String(x.marca);
  if(x.peso)     f.peso     = (Math.round(Number(x.peso)*100000)/100000) + ' kg';
  if(x.volumen)  f.cubicaje = (Math.round(Number(x.volumen)*100000)/100000) + ' ft\u00b3';
  if(x.codebars) f.barra    = String(x.codebars);
  // Como lo escribe el informe de recepcion: "24 PZA X 1 BULTO".
  f.empaque = ub + ' PZA X 1 BULTO';

  return Object.keys(f).length ? f : null;
}

function vtEscribir(metodo, tabla, cuerpo, devolver){
  return fetch(SB+'/rest/v1/'+tabla, {
    method: metodo,
    headers: {'apikey':KEY, 'Authorization':'Bearer '+AUTHTOK(),
              'Content-Type':'application/json',
              'Prefer': devolver ? 'return=representation' : 'return=minimal'},
    body: JSON.stringify(cuerpo)
  }).then(async function(r){
    if(!r.ok) throw new Error((await r.text()).slice(0,180));
    return devolver ? r.json() : null;
  });
}

// ── El enlace, listo para WhatsApp ──────────────────────────────────────────
function vtMostrarEnlace(cod, pin, dias, cliente, n, pedido){
  var url = location.origin + VT_BASE + '?v=' + cod;
  var texto = pedido
    ? ('Hola! Aquí tiene su pedido #' + pedido + ' para revisar:\n' + url + '\n'
       + (pin ? ('Código de acceso: ' + pin + '\n') : '')
       + 'Si algo no está bien, cámbielo y envíelo. Yo se lo confirmo antes de despacharlo.')
    : ('Hola! Te preparé una selección de ' + n + ' productos con tus precios:\n'
       + url + '\n'
       + (pin ? ('Código de acceso: ' + pin + '\n') : '')
       + 'Vence en ' + dias + ' días.');

  var m=document.createElement('div');
  m.id='vt-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;'
    +'max-width:460px;width:100%;padding:20px">'
    +'<div style="font-size:16px;font-weight:700;margin-bottom:4px">'
    +(pedido ? ('Revisión del pedido #'+vtEsc(pedido)) : 'Vitrina lista')+'</div>'
    +'<div style="font-size:13px;color:var(--text3);margin-bottom:14px">'
    +n+' producto(s) para '+vtEsc(cliente)
    +(pedido ? '<br>El pedido no se tocará: lo que pida el cliente te llegará para que lo confirmes.' : '')
    +'</div>'
    +'<div style="background:var(--bg);border-radius:9px;padding:11px;'
    +'font-size:12.5px;word-break:break-all;margin-bottom:10px">'+vtEsc(url)+'</div>'
    +(pin?('<div style="background:#FFFBEB;border:1px solid #FDE68A;color:#92400E;'
      +'border-radius:9px;padding:10px 12px;font-size:13px;margin-bottom:12px">'
      +'Código de acceso: <b style="font-size:17px;letter-spacing:.1em">'+pin+'</b><br>'
      +'<span style="font-size:11.5px">Díctaselo por teléfono, no lo mandes en el mismo '
      +'mensaje: si reenvían el chat, va el código dentro.</span></div>'):'')
    +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<button class="btn" style="background:#25D366;color:#fff;border-color:#25D366;'
      +'display:inline-flex;align-items:center;gap:7px" '
      +'onclick="vtWhats('+JSON.stringify(texto).replace(/"/g,'&quot;')+')">'
      +'<svg viewBox="0 0 32 32" width="16" height="16" aria-hidden="true">'
      +'<path fill="#fff" d="M16 3.2C8.9 3.2 3.2 8.9 3.2 16c0 2.3.6 4.4 1.7 6.3L3.2 28.8l6.7-1.7'
      +'c1.8 1 3.9 1.6 6.1 1.6 7.1 0 12.8-5.7 12.8-12.8S23.1 3.2 16 3.2zm0 23c-1.9 0-3.7-.5-5.3-1.4'
      +'l-.4-.2-4 1 1.1-3.9-.3-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.7 4.7-10.4 10.4-10.4S26.4 10.3 26.4 16'
      +' 21.7 26.2 16 26.2z"/>'
      +'<path fill="#fff" d="M21.7 18.9c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2s-.8 1-1 1.2c-.2.2-.4.2-.7.1'
      +'-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6'
      +'l-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.7s1.2 3.1 1.4 3.4'
      +'c.2.2 2.4 3.7 5.8 5.1.8.3 1.4.6 1.9.7.8.3 1.5.2 2.1.1.6-.1 1.8-.8 2.1-1.5.3-.7.3-1.4.2-1.5'
      +'-.1-.2-.3-.3-.6-.4z"/></svg>Abrir WhatsApp</button>'
      +'<button class="btn" onclick="vtCopiar('+JSON.stringify(texto).replace(/"/g,'&quot;')+')">'
      +'Copiar mensaje</button>'
      +'<button class="btn" style="margin-left:auto" '
      +'onclick="document.getElementById(\'vt-modal\').remove()">Cerrar</button>'
    +'</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}

function vtWhats(texto){
  window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank');
}
function vtCopiar(texto){
  try{
    navigator.clipboard.writeText(texto);
    alert('Mensaje copiado. Pégalo en WhatsApp.');
  }catch(e){
    prompt('Copia este mensaje:', texto);
  }
}

// ── Seguimiento ─────────────────────────────────────────────────────────────
async function vtCargar(){
  var cond='select=*&order=creado_en.desc&limit=60';
  // Un vendedor ve las suyas; administracion, todas.
  var rol=String((CU&&CU.rol)||'').toLowerCase();
  if(['admin','administrador','gerencia'].indexOf(rol)<0){
    cond+='&vendedor=eq.'+encodeURIComponent(vtYo());
  }
  try{ VT_LISTA = await qAll('vitrinas', cond) || []; }
  catch(e){ VT_LISTA = []; }
  vtRender();
}

function vtRender(){
  var c=document.getElementById('vt-lista'); if(!c) return;
  if(!VT_LISTA.length){
    c.innerHTML='<div class="card" style="text-align:center;padding:26px;color:var(--text3)">'
      +'Todavía no has mandado ninguna vitrina.<br>'
      +'<span style="font-size:12.5px">Arma un pedido en Nuevo pedido y pulsa '
      +'«Mandar por WhatsApp».</span></div>';
    return;
  }
  var h='<div style="overflow-x:auto"><table class="tbl">'
    +'<tr><th>Cliente</th><th>Enviada</th><th style="text-align:right">Aperturas</th>'
    +'<th>Última vista</th><th>Estado</th><th></th></tr>';
  VT_LISTA.forEach(function(v){
    var venc = new Date(v.vence_en) < new Date();
    var est = v.pedido_id
      ? '<span class="badge b-green">Pidió</span>'
      : (venc ? '<span class="badge b-gray">Vencida</span>'
              : (v.aperturas ? '<span class="badge b-amber">La abrió</span>'
                             : '<span class="badge b-gray">Sin abrir</span>'));
    h+='<tr>'
      +'<td>'+vtEsc(v.cardname||v.cardcode)+'</td>'
      +'<td style="font-size:12px;white-space:nowrap">'+_prFechaHora(v.creado_en)+'</td>'
      +'<td style="text-align:right">'+(v.aperturas||0)+'</td>'
      +'<td style="font-size:12px;white-space:nowrap">'
        +(v.ultima_vista?_prFechaHora(v.ultima_vista):'—')+'</td>'
      +'<td>'+est+'</td>'
      +'<td style="text-align:right;white-space:nowrap">'
        +'<button class="btn btn-sm" onclick="vtDetalle('+v.id+')">Ver</button></td>'
      +'</tr>';
  });
  c.innerHTML=h+'</table></div>';
}

// Lo que miro y no pidio: el motivo de la llamada del dia siguiente.
async function vtDetalle(id){
  var v=VT_LISTA.filter(function(x){ return x.id===id; })[0];
  if(!v) return;
  var ev=[], items=[];
  try{
    ev = await qAll('vitrina_eventos',
      'select=tipo,itemcode,cantidad,creado_en&vitrina_id=eq.'+id+'&order=creado_en') || [];
    items = await qAll('vitrina_items',
      'select=itemcode,itemname&vitrina_id=eq.'+id) || [];
  }catch(e){}

  var nom={}; items.forEach(function(i){ nom[i.itemcode]=i.itemname||i.itemcode; });
  var vistos={}, pedidos={};
  ev.forEach(function(e){
    if(e.tipo==='ver') vistos[e.itemcode]=(vistos[e.itemcode]||0)+1;
    if(e.tipo==='agregar') pedidos[e.itemcode]=Number(e.cantidad)||0;
  });
  // Lo interesante: lo que miro varias veces y acabo sin pedir.
  var dudo=Object.keys(vistos).filter(function(c){ return !pedidos[c]; })
            .sort(function(a,b){ return vistos[b]-vistos[a]; });

  var m=document.createElement('div');
  m.id='vt-det';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;'
    +'max-width:520px;width:100%;max-height:88vh;overflow-y:auto;padding:20px">'
    +'<div style="font-size:16px;font-weight:700">'+vtEsc(v.cardname||v.cardcode)+'</div>'
    +'<div style="font-size:12.5px;color:var(--text3);margin-bottom:14px">'
      +(v.aperturas||0)+' apertura(s) · '
      +(v.ultima_vista?('última '+_prFechaHora(v.ultima_vista)):'sin abrir')+'</div>'
    +(dudo.length
      ? ('<div style="font-size:13px;font-weight:700;margin-bottom:7px">'
         +'Miró y no pidió</div>'
         +'<div style="font-size:13px;line-height:1.8;margin-bottom:14px">'
         + dudo.slice(0,8).map(function(c){
             return '· '+vtEsc(nom[c]||c)+' <span style="color:var(--text3)">('
               +vistos[c]+' vez/veces)</span>'; }).join('<br>')
         +'</div>')
      : '<div style="font-size:13px;color:var(--text3);margin-bottom:14px">'
        +'Todavía no hay nada que destacar.</div>')
    +'<div style="text-align:right">'
      +'<button class="btn" onclick="document.getElementById(\'vt-det\').remove()">'
      +'Cerrar</button></div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}


/* ══════════════════════════════════════════════════════════════════════════
   LO QUE PIDIO EL CLIENTE
   ---------------------------------------------------------------------------
   El vendedor ve su pedido al lado de lo que pide el cliente, linea por
   linea, y decide. Nada se aplica solo.

   Los cambios que acepte van por `pedidos_cambios_queue`, el mismo camino
   que ya usa el portal para modificar un pedido en SAP. No se inventa una
   via nueva para esto: la que hay esta probada y toca lo justo.
   ══════════════════════════════════════════════════════════════════════════ */

// Aviso en la pantalla del pedido cuando el cliente ya respondio.
async function vtRevisionPedido(docnum){
  var c = document.getElementById('ped-revision');
  if(!c) return;
  try{
    var r = await q('vitrinas',
      'select=id,codigo,cardname,respondida_en,respuesta,revision'
      + '&pedido_docnum=eq.' + encodeURIComponent(docnum)
      + '&order=creado_en.desc&limit=1') || [];
    if(!r.length){ c.innerHTML=''; return; }
    var v = r[0];

    if(!v.respondida_en){
      c.innerHTML = '<div class="card" style="border-color:var(--amber);'
        + 'background:var(--amber-bg);font-size:13px;padding:11px 14px">'
        + '\u23f3 Le mandaste este pedido al cliente para que lo revise. '
        + 'Todav\u00eda no ha respondido.</div>';
      return;
    }
    if(v.revision === 'aplicada' || v.revision === 'descartada'){
      c.innerHTML = '<div class="card" style="font-size:12.5px;color:var(--text3);'
        + 'padding:10px 14px">El cliente revis\u00f3 este pedido y ya lo '
        + (v.revision === 'aplicada' ? 'aplicaste' : 'descartaste') + '.</div>';
      return;
    }

    var resp = v.respuesta || {};
    try{ if(typeof resp === 'string') resp = JSON.parse(resp); }catch(e){ resp = {}; }
    var n = Number(resp.cambios)||0;

    c.innerHTML = '<div class="card" style="border-color:'
      + (n ? 'var(--red)' : 'var(--green)') + ';background:'
      + (n ? 'var(--red-bg)' : 'var(--green-bg)') + ';padding:12px 14px">'
      + '<div style="font-size:13.5px;font-weight:700;color:'
      + (n ? 'var(--red)' : 'var(--green)') + '">'
      + (n ? ('\ud83d\udd14 El cliente pide ' + n + ' cambio(s)')
           : '\u2705 El cliente acept\u00f3 el pedido tal cual') + '</div>'
      + '<div style="font-size:12.5px;color:var(--text2);margin:4px 0 10px">'
      + 'Respondi\u00f3 el ' + _prFechaHora(v.respondida_en)
      + '. El pedido no se ha tocado.</div>'
      + '<button class="btn btn-sm btn-p" onclick="vtVerRevision(' + v.id + ','
      + docnum + ')">Ver lo que pide</button></div>';
  }catch(e){ c.innerHTML=''; }
}

async function vtVerRevision(vid, docnum){
  var v, items=[];
  try{
    var r = await q('vitrinas', 'select=*&id=eq.'+vid+'&limit=1') || [];
    v = r[0];
    items = await qAll('vitrina_items',
      'select=itemcode,itemname,cantidad,precio,bulto&vitrina_id=eq.'+vid
      + '&order=orden') || [];
  }catch(e){ alert('No pude leer la revisi\u00f3n.'); return; }
  if(!v) return;

  var resp = v.respuesta || {};
  try{ if(typeof resp === 'string') resp = JSON.parse(resp); }catch(e){ resp = {}; }
  var pide = {};
  (resp.lineas || []).forEach(function(l){ pide[l.itemcode] = Number(l.quantity)||0; });

  var filas = '', totOrig = 0, totNuevo = 0, hay = 0;
  items.forEach(function(it){
    var antes = Number(it.cantidad)||0;
    // Un articulo que el cliente no manda es que lo quito del pedido.
    var ahora = (pide[it.itemcode] != null) ? pide[it.itemcode] : 0;
    var pre = Number(it.precio)||0;
    totOrig += antes*pre; totNuevo += ahora*pre;
    var dif = ahora - antes;
    if(dif !== 0) hay++;
    filas += '<tr' + (dif!==0 ? ' style="background:var(--red-bg)"' : '') + '>'
      + '<td>' + vtEsc(it.itemname||it.itemcode)
        + '<div style="font-size:11px;color:var(--text3)">' + vtEsc(it.itemcode) + '</div></td>'
      + '<td style="text-align:right">' + antes.toLocaleString('en-US') + '</td>'
      + '<td style="text-align:right;font-weight:' + (dif!==0?'800':'400') + '">'
        + ahora.toLocaleString('en-US') + '</td>'
      + '<td style="text-align:right;font-weight:700;color:'
        + (dif>0?'var(--green)':(dif<0?'var(--red)':'var(--text3)')) + '">'
        + (dif>0?('+'+dif):(dif<0?String(dif):'\u2014')) + '</td>'
      + '<td style="text-align:right">$' + (ahora*pre).toLocaleString('en-US',
          {minimumFractionDigits:2,maximumFractionDigits:2}) + '</td>'
      + '</tr>';
  });

  var m = document.createElement('div');
  m.id = 'vt-rev';
  m.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    + 'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML = '<div style="background:var(--surface,#fff);border-radius:14px;'
    + 'max-width:720px;width:100%;max-height:88vh;overflow-y:auto;padding:20px">'
    + '<div style="font-size:17px;font-weight:700">Pedido #' + vtEsc(docnum) + '</div>'
    + '<div style="font-size:12.5px;color:var(--text3);margin-bottom:14px">'
    + vtEsc(v.cardname||'') + ' \u00b7 respondi\u00f3 el ' + _prFechaHora(v.respondida_en)
    + '</div>'
    + (resp.comentario
        ? ('<div style="background:var(--bg);border-radius:9px;padding:10px 12px;'
           + 'font-size:13px;margin-bottom:12px"><b>Su comentario:</b><br>'
           + vtEsc(resp.comentario) + '</div>')
        : '')
    + '<div style="overflow-x:auto"><table class="tbl">'
    + '<tr><th>Art\u00edculo</th><th style="text-align:right">En el pedido</th>'
    + '<th style="text-align:right">Pide</th><th style="text-align:right">Dif.</th>'
    + '<th style="text-align:right">Importe</th></tr>'
    + filas + '</table></div>'
    + '<div style="display:flex;gap:14px;flex-wrap:wrap;margin-top:12px;'
    + 'font-size:13px;justify-content:flex-end">'
      + '<span style="color:var(--text3)">Pedido: $'
        + totOrig.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
        + '</span>'
      + '<span style="font-weight:800">Lo que pide: $'
        + totNuevo.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})
        + '</span></div>'
    + '<div style="display:flex;gap:8px;margin-top:17px;flex-wrap:wrap">'
      + (hay
          ? ('<button class="btn btn-p" onclick="vtAplicarRevision(' + vid + ','
             + docnum + ')">Pasar los ' + hay + ' cambio(s) al editor</button>')
          : '<span style="font-size:13px;color:var(--green);font-weight:700;'
            + 'align-self:center">No pide ning\u00fan cambio.</span>')
      + '<button class="btn" onclick="vtDescartarRevision(' + vid + ')">'
      + 'Descartar</button>'
      + '<button class="btn" style="margin-left:auto" '
      + 'onclick="document.getElementById(\'vt-rev\').remove()">Cerrar</button>'
    + '</div>'
    + '<div style="font-size:11.5px;color:var(--text3);margin-top:10px">'
    + 'Se abrir\u00e1 el editor del pedido con esas cantidades puestas y '
    + 'marcadas. Nada cambia hasta que guardes.</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}

// Abre el panel de «Editar precios y cantidades» que ya existe, con las
// cantidades del cliente YA PUESTAS y marcadas.
//
// Es mejor que aplicar los cambios a ciegas: el vendedor los ve dentro del
// pedido, puede corregir cualquiera antes de guardar, y al guardar va por el
// camino de siempre, que esta probado. Nada nuevo que pueda fallar.
async function vtAplicarRevision(vid, docnum){
  var m = document.getElementById('vt-rev'); if(m) m.remove();
  try{
    var r = await q('vitrinas', 'select=respuesta&id=eq.'+vid+'&limit=1') || [];
    var resp = r[0] && r[0].respuesta;
    try{ if(typeof resp === 'string') resp = JSON.parse(resp); }catch(e){}
    if(!resp || !resp.lineas) throw new Error('No encuentro lo que pidi\u00f3.');

    var pide = {};
    resp.lineas.forEach(function(l){ pide[l.itemcode] = Number(l.quantity)||0; });

    // Abrir el panel si no lo esta.
    var box = document.getElementById('ped-ed-panel');
    if(box && box.getAttribute('data-open') !== '1'){
      if(typeof pedEditarAbrir === 'function') pedEditarAbrir(docnum);
    }

    // Y poner las cantidades. Se espera a que el panel se pinte.
    setTimeout(function(){
      var puestas = 0, quitadas = 0;
      (window._pedEdLineas || []).forEach(function(l){
        var inp = document.getElementById('pe-q-' + Number(l.linenum));
        if(!inp) return;
        // Lo que el cliente no manda es que lo quito: cero.
        var v = (pide[l.itemcode] != null) ? pide[l.itemcode] : 0;
        var antes = Number(l.quantity)||0;
        if(v === antes) return;

        // Nunca por debajo de lo ya entregado: esa mercancia salio.
        var ent = Number(l.delivrdqty)||0;
        if(v < ent){ v = ent; quitadas++; }

        inp.value = v;
        // Se marca para que se vea de un vistazo que lo cambio el cliente.
        inp.style.borderColor = '#B3261E';
        inp.style.background  = '#FBE9E8';
        inp.style.fontWeight  = '800';
        inp.title = 'El cliente pidi\u00f3 ' + (pide[l.itemcode]!=null?pide[l.itemcode]:0)
                  + ' (el pedido lleva ' + antes + ')';
        try{ inp.dispatchEvent(new Event('input', {bubbles:true})); }catch(e){}
        try{ if(typeof pedEditCalc === 'function') pedEditCalc(Number(l.linenum)); }catch(e){}
        puestas++;
      });
      try{ if(typeof pedEditTotal === 'function') pedEditTotal(); }catch(e){}

      // Un aviso dentro del panel, para que nadie guarde sin saber que es.
      var box2 = document.getElementById('ped-ed-panel');
      if(box2 && !document.getElementById('vt-ed-aviso')){
        var a = document.createElement('div');
        a.id = 'vt-ed-aviso';
        a.style.cssText = 'background:var(--red-bg);border:1px solid var(--red);'
          + 'border-radius:9px;padding:10px 13px;margin-bottom:11px;font-size:13px;'
          + 'color:var(--red);font-weight:600';
        a.innerHTML = 'En rojo, las ' + puestas + ' cantidad(es) que pidi\u00f3 el '
          + 'cliente. Rev\u00edsalas y, si est\u00e1s de acuerdo, guarda. '
          + 'Hasta que guardes, el pedido no cambia.'
          + (quitadas ? ('<br><span style="font-weight:400">' + quitadas
              + ' l\u00ednea(s) no pudieron bajar tanto: ya hay mercanc\u00eda '
              + 'entregada.</span>') : '');
        box2.insertBefore(a, box2.firstChild);
      }

      // La revision queda vista, se guarde o no: ya la tiene delante.
      vtEscribir('PATCH', 'vitrinas?id=eq.'+vid, {revision:'aplicada'})
        .catch(function(){});
      try{ vtRevisionPedido(docnum); }catch(e){}

      if(!puestas) alert('No hab\u00eda ninguna cantidad distinta que poner.');
    }, 320);
  }catch(e){
    alert('No se pudo: ' + (e.message||e));
  }
}

async function vtDescartarRevision(vid){
  if(!confirm('El pedido se queda como est\u00e1 y la revisi\u00f3n se marca como '
      + 'vista.\n\n\u00bfSeguir?')) return;
  try{
    await vtEscribir('PATCH', 'vitrinas?id=eq.'+vid, {revision: 'descartada'});
    var m = document.getElementById('vt-rev'); if(m) m.remove();
  }catch(e){ alert('No se pudo: ' + (e.message||e)); }
}


/* ══════════════════════════════════════════════════════════════════════════
   SHOWROOM — el catalogo entero con los precios de UN cliente
   ---------------------------------------------------------------------------
   A diferencia de la vitrina, aqui no se elige nada: el cliente recorre todo
   lo que hay con existencia y foto, por departamento, y arma su pedido.
   El enlace dura un mes y se le manda una vez.

   Lo que ve de precio es el ULTIMO que pago por cada articulo; si nunca lo
   compro, el de lista. Eso lo calcula el servidor, no esta pagina.
   ══════════════════════════════════════════════════════════════════════════ */

async function vtShowroom(cardcode, cardname){
  if(!cardcode){
    if(typeof npCli !== 'undefined' && npCli && npCli.cardcode){
      cardcode = npCli.cardcode; cardname = npCli.cardname;
    } else { alert('Elige primero el cliente.'); return; }
  }
  try{
    // Si ya tiene uno vivo, se reutiliza en vez de llenar la tabla de
    // enlaces: el cliente guarda el que le mandaron la primera vez.
    var ya = await q('vitrinas',
      'select=codigo,vence_en,pin&tipo=eq.showroom&cardcode=eq.'
      + encodeURIComponent(cardcode) + '&activa=is.true'
      + '&vence_en=gt.' + new Date().toISOString()
      + '&order=creado_en.desc&limit=1') || [];
    if(ya.length){
      var d = Math.max(1, Math.ceil((new Date(ya[0].vence_en) - new Date())/86400000));
      vtShowEnlace(ya[0].codigo, ya[0].pin, d, cardname || cardcode, true);
      return;
    }

    var cod = vtCodigo(7), dias = 30;
    var v = await vtEscribir('POST', 'vitrinas', {
      codigo: cod,
      tipo: 'showroom',
      cardcode: cardcode,
      cardname: cardname || cardcode,
      slpcode: (CU && CU.slpcode) || null,
      vendedor: vtYo(),
      vendedor_nom: vtNombre(),
      titulo: 'Showroom',
      mensaje: 'Este es nuestro cat\u00e1logo con sus precios. '
             + 'Arme su pedido y yo se lo confirmo.',
      pin: null,
      vence_en: new Date(Date.now() + dias*86400000).toISOString()
    }, true);
    if(!v || !v[0]) throw new Error('No se pudo crear el showroom.');
    vtShowEnlace(cod, null, dias, cardname || cardcode, false);
  }catch(e){
    alert('No se pudo preparar el showroom: ' + (e.message||e));
  }
}

function vtShowEnlace(cod, pin, dias, cliente, yaExistia){
  var url = location.origin + SH_BASE + '?v=' + cod;
  var texto = 'Hola! Aqu\u00ed tiene nuestro cat\u00e1logo completo con sus precios:\n'
    + url + '\n'
    + (pin ? ('C\u00f3digo de acceso: ' + pin + '\n') : '')
    + 'Puede armar su pedido cuando quiera y yo se lo confirmo.';

  var m=document.createElement('div');
  m.id='vt-modal';
  m.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;'
    +'display:flex;align-items:center;justify-content:center;padding:14px';
  m.innerHTML='<div style="background:var(--surface,#fff);border-radius:14px;'
    +'max-width:470px;width:100%;padding:20px">'
    +'<div style="font-size:16px;font-weight:700;margin-bottom:4px">'
    +'Showroom de '+vtEsc(cliente)+'</div>'
    +'<div style="font-size:13px;color:var(--text3);margin-bottom:14px">'
    +(yaExistia
       ? ('Ya ten\u00eda uno abierto, as\u00ed que es el mismo enlace. Vence en '
          + dias + ' d\u00edas.')
       : ('Ve todo el cat\u00e1logo con existencia, con SUS precios. Vence en '
          + dias + ' d\u00edas.'))
    +'</div>'
    +'<div style="background:var(--bg);border-radius:9px;padding:11px;'
    +'font-size:12.5px;word-break:break-all;margin-bottom:12px">'+vtEsc(url)+'</div>'
    +'<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +'<button class="btn" style="background:#25D366;color:#fff;border-color:#25D366" '
      +'onclick="vtWhats('+JSON.stringify(texto).replace(/"/g,'&quot;')+')">'
      +'Abrir WhatsApp</button>'
      +'<button class="btn" onclick="vtCopiar('
      +JSON.stringify(texto).replace(/"/g,'&quot;')+')">Copiar mensaje</button>'
      +'<button class="btn" style="margin-left:auto" '
      +'onclick="document.getElementById(\'vt-modal\').remove()">Cerrar</button>'
    +'</div>'
    +'<div style="font-size:11.5px;color:var(--text3);margin-top:11px">'
    +'Lo que pida entra como pedido a revisar. Nada va a SAP sin que lo '
    +'apruebes.</div></div>';
  document.body.appendChild(m);
  m.addEventListener('click', function(e){ if(e.target===m) m.remove(); });
}
